import { useState, useCallback, useImperativeHandle, forwardRef, type ReactNode } from 'react';

interface NPSDSearchFiltersProps {
  activeFilterCount?: number;
  loading?: boolean;
  onSearch?: () => void;
  children?: ReactNode;
}

export interface NPSDSearchFiltersRef {
  collapse: () => void;
}

export const NPSDSearchFilters = forwardRef<NPSDSearchFiltersRef, NPSDSearchFiltersProps>(
  function NPSDSearchFilters(
    { activeFilterCount = 0, loading = false, onSearch, children },
    ref
  ) {
    const [filtersExpanded, setFiltersExpanded] = useState(true);

    const toggleFilters = useCallback(() => {
      setFiltersExpanded((prev) => !prev);
    }, []);

    const handleSearch = useCallback(() => {
      setFiltersExpanded(false);
      onSearch?.();
    }, [onSearch]);

    const collapse = useCallback(() => {
      setFiltersExpanded(false);
    }, []);

    useImperativeHandle(ref, () => ({
      collapse,
    }), [collapse]);

    return (
      <div className="npsd-search-filters-wrapper">
        {/* Mobile Filters Toggle Bar */}
        <div className="mobile-filters-bar">
          <button className="btn-filters-toggle" onClick={toggleFilters}>
            <i className="fa fa-filter"></i>
            {' '}Filters
            {activeFilterCount > 0 && (
              <span className="filter-count-badge">{activeFilterCount}</span>
            )}
            {' '}<i className={`fa ${filtersExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
          </button>
          {!filtersExpanded && (
            <button className="btn-search-mobile" onClick={handleSearch} disabled={loading}>
              <i className="fa fa-search"></i> Search
            </button>
          )}
        </div>

        {/* Search Form Slot */}
        <div className={`search-form${filtersExpanded ? ' filters-expanded' : ''}`}>
          {children}
        </div>
      </div>
    );
  }
);

(window as any).NPSDSearchFiltersReact = NPSDSearchFilters;
